import { Controller } from "@hotwired/stimulus";

// shows the locations target after a city is selected in a fleet program checkout form
export default class extends Controller {
  change() {
    const citySelect = this.element.querySelector(
      '[data-checkout-forms--location-dropdowns-target="citySelect"]'
    );
    const locationsDiv = this.element.querySelector(
      '[data-checkout-forms--location-dropdowns-target="locations"]'
    );

    if (citySelect && citySelect.value && locationsDiv) {
      locationsDiv.hidden = false;
    }
  }
}
